import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Row } from 'react-bootstrap'
import { useHistory, withRouter } from 'react-router-dom'
import ListSelections from './list-selections'
import ContactPresentation from './contact-presentation'
import DashboardSingleContactListAddCsvModal from './modals/add-csv-modal'
import DashboardSingleContactListAddSingleModal from './modals/add-single-modal'
import DashboardSingleContactListEditSingleModal from './modals/edit-single-contact-modal'
import DashboardSingleContactListDeleteSingleModal from './modals/delete-single-modal'
import { ToastContainer } from 'react-toastify'
import { changeSingleContactListModal, resetActiveContactDeletion, resetActiveContactDisplay, resetAddCsvRecord, resetAddSingleRecord, resetDeleteContactsArray, resetDeleteSingleContact, resetEditContactDisplay, resetSingleContactListRecords, resetSingleContactVerification, resetUpdateSingleContactDisplay, retrieveSingleContactListDetails, retrieveSingleContactListRecords, selectSingleContactDisplay, setActiveContactDisplay } from '../../../redux/actions/single-contact-list'
import { sendErrorNotification, sendSuccessNotification } from '../../universal/notifications/notifications'
import './style.scss'

const Index = props => {

	const listId = props.match.params.id

	const dispatch = useDispatch()
	const history = useHistory()

    const modal = useSelector(state => state.singleContactList.showModals)
	const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
	const records = useSelector(state => state.singleContactList.records)
	const activeDisplay = useSelector(state => state.singleContactList.activeDisplay)

	const [maintainLayout, _] = useState(false)
	const [firstLoad, setFirstLoad] = useState(false)

	const addSingleError = useSelector(state => state.singleContactList.addSingleRecord.error)
    const addSingleStatus = useSelector(state => state.singleContactList.addSingleRecord.status)

	const addCsvError = useSelector(state => state.singleContactList.addSingleCsv.error)
    const addCsvStatus = useSelector(state => state.singleContactList.addSingleCsv.status)

	const updateSingleError = useSelector(state => state.singleContactList.updateSingleRecord.error)
	const updateSingleStatus = useSelector(state => state.singleContactList.updateSingleRecord.status)

	const deleteArrayError = useSelector(state => state.singleContactList.deleteArray.error)
    const deleteArrayStatus = useSelector(state => state.singleContactList.deleteArray.status)

	const deleteError = useSelector(state => state.singleContactList.deleteSingleRecord.error)
    const deleteStatus = useSelector(state => state.singleContactList.deleteSingleRecord.status)

	const fetchLoading = useSelector(state => state.singleContactList.fetchDetails.loading)
	const fetchError = useSelector(state => state.singleContactList.fetchDetails.error)


	const flushDetails = () => {
		dispatch(resetActiveContactDisplay())
		dispatch(resetSingleContactListRecords())
		dispatch(resetEditContactDisplay())
	}

	useEffect(() => {
		flushDetails()
	}, [])

	useEffect(() => {
		if(!fetchLoading && fetchError){
			flushDetails()
			history.push('/dashboard/kontaktlister')
		}
	}, [fetchError])

	useEffect(() => {
		if(listId && selectedCompany){
			dispatch(retrieveSingleContactListDetails({companyId: selectedCompany, id: listId}))
			dispatch(retrieveSingleContactListRecords({companyId: selectedCompany, id: listId}))
		}
	}, [listId, selectedCompany])

	useEffect(() => {
		if(records && records.length > 0 && !firstLoad){
			dispatch(setActiveContactDisplay(records[0]))
			setFirstLoad(true)
		}
	}, [records])

	useEffect(() => {
		if(addSingleError){
			sendErrorNotification("Kunne ikke legge til kontakt.")
			dispatch(resetAddSingleRecord())
		}
	}, [addSingleError])

	useEffect(() => {
		if(addSingleStatus && addSingleStatus === "success"){
			sendSuccessNotification("Kontakten ble lagt til.")
			dispatch(resetAddSingleRecord())
			dispatch(retrieveSingleContactListRecords({companyId: selectedCompany, id: listId}))
		}
	}, [addSingleStatus])

	useEffect(() => {
		if(updateSingleError){
			sendErrorNotification("Kunne ikke oppdatere kontakt.")
			dispatch(resetUpdateSingleContactDisplay())
		}
	}, [updateSingleError])

	useEffect(() => {
		if(updateSingleStatus && updateSingleStatus === "success"){
			sendSuccessNotification("Kontakten ble oppdatert.")
			dispatch(resetUpdateSingleContactDisplay())
		}
	}, [updateSingleStatus])

	useEffect(() => {
		if(deleteArrayError){
		  sendErrorNotification("Kunne ikke slette valgte kontakter.")
		  dispatch(resetDeleteContactsArray())
		  dispatch(resetEditContactDisplay())
		  dispatch(retrieveSingleContactListRecords({companyId: selectedCompany, id: listId}))
		}
		if(deleteArrayStatus){
			if(deleteArrayStatus && deleteArrayStatus.length > 1){
				if(deleteArrayStatus.filter(e => e.payload === activeDisplay.id).length > 0){
					dispatch(resetActiveContactDisplay())
				}
			} else {
				if(deleteStatus === activeDisplay.id){
					dispatch(resetActiveContactDisplay())
				}
			}
		  sendSuccessNotification("Valgte kontakter ble slettet.")
		  dispatch(resetDeleteContactsArray())
		  dispatch(resetEditContactDisplay())
		  dispatch(retrieveSingleContactListRecords({companyId: selectedCompany, id: listId}))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [deleteArrayStatus, deleteArrayError])

	useEffect(() => {
		if(deleteStatus){

			if(deleteStatus === activeDisplay.id){
				dispatch(resetActiveContactDisplay())
			}

			sendSuccessNotification("Kontakten ble slettet.")
			dispatch(resetDeleteSingleContact())
			dispatch(resetActiveContactDeletion())
			dispatch(retrieveSingleContactListRecords({companyId: selectedCompany, id: listId}))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [deleteStatus])

	useEffect(() => {
		if(deleteError){
			sendErrorNotification("Kunne ikke slette kontakt.")
			dispatch(resetDeleteSingleContact())
			dispatch(resetActiveContactDeletion())
			dispatch(retrieveSingleContactListRecords({companyId: selectedCompany, id: listId}))
		  }
	}, [deleteError])

	useEffect(() => {
		if(addCsvError){
			sendErrorNotification("Kunne ikke legge til kontakter.")
			dispatch(resetAddCsvRecord())
		}
	}, [addSingleError])

	useEffect(() => {
		if(addCsvStatus && addCsvStatus === "success"){
			sendSuccessNotification("Kontaktene ble lagt til.")
			dispatch(resetAddCsvRecord())
			dispatch(retrieveSingleContactListRecords({companyId: selectedCompany, id: listId}))
		}
	}, [addCsvStatus])


	return(
		<section className="dashboard-single-contact-list-section">
			<div className="inner-dashboard-single-contact-list-container">
				<Row className="dashboard-single-contact-list-row">
					<ListSelections maintainLayout={maintainLayout}/>
					<ContactPresentation/>
				</Row>
                {modal.addCsvModal ? <DashboardSingleContactListAddCsvModal/>:null}
				{modal.addSingleModal ? <DashboardSingleContactListAddSingleModal/>:null}
				{modal.editSingleModal ? <DashboardSingleContactListEditSingleModal/>:null}
				{modal.deleteSingleModal ? <DashboardSingleContactListDeleteSingleModal/>:null}
			</div>
			<ToastContainer/>
		</section>
	)
}

export default withRouter(Index)

